<template>
  <div class="upload-button" @click="handleImport">
    <slot>
      <a-button style="width: 88px" type="primary">上传文件</a-button>
    </slot>
    <input
      v-show="false"
      ref="fileupload"
      type="file"
      name="fileupload"
      :value="uploadFile"
      @change.stop="fileChange"
    />
  </div>
</template>

<script>
export default {
  name: 'UploadFile',

  data() {
    return {
      uploadFile: '', // 上传的文件
      uploadFileInfo: {}
    }
  },

  methods: {
    handleImport() {
      this.$refs.fileupload.click()
    },

    fileChange(e) {
      const fileList = Array.from(e.currentTarget.files)

      if (!fileList[0]) {
        return false
      }

      this.$refs.fileupload.value = ''

      this.uploadFileInfo = fileList[0]
      this.$emit('upload', fileList[0])
    }
  }
}
</script>

<style scoped lang="scss"></style>
